import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n";

export default function Landing() {
  const navigate = useNavigate();
  const { t } = useLang();
  
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="landing-page">
      <div className="flex-1 flex flex-col justify-center px-8">
        <div className="max-w-md mx-auto w-full">
          <div className="mb-20">
            <h1 className="text-4xl font-medium tracking-tight text-gray-900 mb-3">
              ADE
            </h1>
            <p className="text-lg text-gray-400">
              {t('hereNow')}
            </p>
          </div>
          
          <div className="space-y-3">
            <Button 
              data-testid="enter-btn"
              variant="outline"
              className="w-full h-11 rounded-lg border-gray-200 text-gray-700 hover:bg-gray-50 font-normal text-base"
              onClick={() => navigate('/login')}
            >
              {t('enter')}
            </Button>
            <Button 
              data-testid="register-btn"
              variant="ghost"
              className="w-full h-11 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-50 font-normal text-base"
              onClick={() => navigate('/register')}
            >
              {t('createAccount')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
